export default {
    controller: 'reservationItemsController',
    template: require('../views/reservationItems.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/basket/components/reservationItems.component.js